import React from "react";
import { NavLink, Route, Switch, Redirect } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import ConversationsList from "./ConversationsList";
import "./superTickets.css";

const GET_UNREPLIED_COUNT = gql`
  query getUnrepliedTicketsForTabs {
    getConversationsCount(filters: { repliedByAdmin: false, closed: false })
  }
`;

/**
 * Conversations - the tabbed ticket queues.
 *
 * The three tabs used to be three ~1,150-line files that were copies of
 * each other differing only in two filter booleans; they are now one
 * ConversationsList told which queue to show.
 *
 * The default tab is Unreplied rather than Closed. Landing on the
 * archive of resolved tickets put the one queue that needs attention two
 * clicks away, and the tab carries the count so the size of that queue
 * is visible from the other two.
 */
const Conversations = () => {
  const { data } = useQuery(GET_UNREPLIED_COUNT, {
    pollInterval: 60000,
    fetchPolicy: "cache-and-network",
  });
  const unreplied = (data && data.getConversationsCount) || 0;

  return (
    <div className="superTicketsShell">
      <nav className="superTicketsTabs">
        <NavLink
          className="superTicketsTab"
          activeClassName="isActive"
          to="/superAdmin/tickets/UnrepliedTickets"
        >
          Unreplied
          {unreplied > 0 && (
            <span className="superTicketsTabCount">{unreplied > 99 ? "99+" : unreplied}</span>
          )}
        </NavLink>
        <NavLink
          className="superTicketsTab"
          activeClassName="isActive"
          to="/superAdmin/tickets/RepliedTickets"
        >
          Replied
        </NavLink>
        <NavLink
          className="superTicketsTab"
          activeClassName="isActive"
          to="/superAdmin/tickets/ClosedTickets"
        >
          Closed
        </NavLink>
      </nav>

      <Switch>
        <Route
          exact
          path="/superAdmin/tickets/UnrepliedTickets"
          render={() => <ConversationsList key="unreplied" status="unreplied" />}
        />
        <Route
          exact
          path="/superAdmin/tickets/RepliedTickets"
          render={() => <ConversationsList key="replied" status="replied" />}
        />
        <Route
          exact
          path="/superAdmin/tickets/ClosedTickets"
          render={() => <ConversationsList key="closed" status="closed" />}
        />
        <Redirect from="/superAdmin/tickets" to="/superAdmin/tickets/UnrepliedTickets" />
      </Switch>
    </div>
  );
};

export default Conversations;
